import React from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { SparklesIcon } from "lucide-react";
import { useLearner } from "../../contexts/LearnerContext";
import { Tag } from "../ui/Tag";
import { spring } from "../../utils/motion";
const tabs = [{
  to: "/app/profile",
  label: "Progress"
}, {
  to: "/app/profile/subscription",
  label: "Subscription"
}, {
  to: "/app/profile/settings",
  label: "Settings"
}];
export function ProfileHeader() {
  const {
    user,
    plan
  } = useLearner();
  const {
    pathname
  } = useLocation();
  return <div data-id="element-1108" data-mp="2mkiwx0h4186q">
      <div className="flex items-center gap-4" data-id="element-1109" data-mp="2mlc585vpw5qz">
        <span className="grid h-16 w-16 shrink-0 place-items-center rounded-card border-3 border-line bg-accent text-xl font-bold text-night shadow-brutal-sm md:h-20 md:w-20 md:text-2xl" data-id="element-1110" data-mp="2mk11u766p00e">
          {user.initials}
        </span>
        <div className="min-w-0" data-id="element-1111" data-mp="n7okyoa6qw70">
          <h1 className="truncate text-2xl font-bold tracking-[-0.02em] md:text-3xl" data-id="element-1112" data-mp="n8q7pq0kd74k">{user.name}</h1>
          <p className="mt-1 flex flex-wrap items-center gap-2 text-sm text-ink-2" data-id="element-1113" data-mp="2y1qx97q1k9o2">
            Learning since {user.joined}
            <Tag tone={plan === "plus" ? "brand" : "neutral"} icon={plan === "plus" ? SparklesIcon : undefined} data-id="element-1114" data-mp="322uenynqmdre">
              {plan === "plus" ? "Plus" : "Free plan"}
            </Tag>
          </p>
        </div>
      </div>
      <nav aria-label="Profile" className="mt-6 flex gap-1 border-b-3 border-line" data-id="element-1115" data-mp="3btyrosturojl">
        {tabs.map(t => {
        const active = pathname === t.to;
        return <Link key={t.to} to={t.to} aria-current={active ? "page" : undefined} className={`focus-ring relative rounded-t-xl px-4 py-2.5 text-sm font-semibold ${active ? "text-ink" : "text-ink-2 hover:text-ink"}`} data-id="element-1116" data-mp="3logxc3itxu61">
              {t.label}
              {active && <motion.span layoutId="profile-tab" transition={spring.snappy} className="absolute inset-x-2 -bottom-[3px] h-[5px] rounded-full bg-brand" aria-hidden="true" data-id="element-1117" data-mp="20cp6o1v2sog6" />}
            </Link>;
      })}
      </nav>
    </div>;
}